import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Dependencies
import DOMPurify from 'dompurify';

// Components
import * as icons from '../Icons/Icons';

const EnrollIntro = observer(class EnrollIntro extends React.Component {
  constructor() {
    super();
    this.next = this.next.bind(this);
  }

  next(e) {
    if(this.props.smarterID) {
      this.props.nextStep(e);
      this.props.setDisplayStep(2);
    } else {
      this.props.setStep(e, 5);
      this.props.setDisplayStep(2);
    }
  }

  render() {
    const { translation } = this.props;

    return(
      <div className={`panel panel--brief ${this.props.isActive}`}>
        <h1 className="panel__title">{translation.heading}</h1>

        {this.props.smarterID &&
          <div dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(translation.body_sid)}}></div>
        }

        {!this.props.smarterID &&
          <div dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(translation.body)}}></div>
        }

        <button className="btn btn--icn-right next" onClick={(e) => {this.next(e)}}>
          {translation.button}
          <icons.iconCircleRight />
        </button>
      </div>
    );
  }
})

export default translate('EnrollIntro')(EnrollIntro);


// WEBPACK FOOTER //
// ./src/app/components/Enroll/EnrollIntro.js